<template>
  <dg-field-container :field_is_textarea="type == 'textarea'" :field_mark="field_mark" :field_span="field_span"
                      :field_textarea_rows="rows" :field_validate_message="validateMessage"
                      :label_span="label_span" :textarea_error_top_margin="textarea_error_top_margin">
    <template v-slot:label>
      <dg-label-field :label="label" :translate="translateLabel" v-if='label'></dg-label-field>
    </template>
    <template v-slot:field>
      <div v-if="editable">
        <el-input :autocomplete="htmlautocomplete" :class="inputClass" :disabled="disabled"
                  :maxlength="maxLength" :placeholder="placeholder" :readonly="readonly" :rows="rows"
                  :show-password="showPassword" :size="fieldSize" :type="type"
                  @blur="!liveUpdate ? updateValue() : null"
                  @input="liveUpdate ? updateValue() : null" class="devegram-input-text-field" v-model="field_value">
          <template slot="prepend" v-if="inputPrepend">{{ inputPrepend }}</template>
          <template slot="append" v-if="inputAppend">{{ inputAppend }}</template>
        </el-input>
        <slot name="field_note"></slot>
      </div>
      <div v-else>
        <dg-label-field :label="field_value" :translate="false" v-if="viewType == 'text' || viewType == 'textarea'"></dg-label-field>
        <a :href="field_value" target="_blank" v-if="viewType == 'link'">{{ field_value }}</a>
      </div>
    </template>
  </dg-field-container>
</template>

<script>
import inputField from './../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
    type: {
      required: false,
      default: 'text'
    },
    maxLength: {
      required: false,
      default: ''
    },
    rows: {
      required: false,
      default: 2
    },
    showPassword: {
      required: false,
      default: false
    },
    htmlautocomplete: {
      required: false,
      default: 'on'
    },
    textarea_error_top_margin: {
      required: false,
      default: 20
    },
    viewType: {
      required: false,
      default: 'text'
    }
  },
  data() {
    return {
      field_value: null
    }
  }
}
</script>
